let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("glWzP"), load("dviIw")]).then(() => parcelRequire('ieevf'));